import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/sku")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+SKUManagement")),
  head: () => ({ meta: seo({ title: "SKUs" }) }),
});
